import { LengthTokenValue } from 'designSystem/types';
import * as S from './styles';

interface LengthTokenPreviewProps {
	value: LengthTokenValue;
}

export const LengthTokenPreview = ({ value }: LengthTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.LengthBar width={value.px || value.numericValue * 16} />
		</S.PreviewContainer>
	);
};
